import { getVersion } from '@/backend/version'

const EXPECTED = 'EXPECTED'
const CURRENT = 'CURRENT'
const AVAILABLE = 'AVAILABLE'

const state = {
  current: process.env.APP_VERSION,
  available: null,
  expected: null,
}

const mutations = {
  [EXPECTED] (state, version) {
    state.expected = version
  },
  [CURRENT] (state, version) {
    state.current = version
  },
  [AVAILABLE] (state, version) {
    state.available = version
  }
}

const actions = {
  available({ commit }) {
    getVersion()
      .then(response => {
        if (response.status == 200) {
          commit(AVAILABLE, response.data.version)
        }
      })
      .catch(error => console.error(error));
  },
  outdated({ dispatch, commit }, version) {
    commit(EXPECTED, version)

    dispatch('available')
  }
}

const getters = {
  current: (state) => state.current,
  isNewAvailable: (state) => {
    return (
      state.available !== null &&
      state.expected !== null &&
      semver.eq(state.available, state.expected)
    )
  },
  isUpToDate: (state) => {
    return (
      state.expected === null ||
      semver.gte(state.current, state.expected)
    )
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/common/version.js